.issue-summary-container {
  display: flex;
  align-items: center;
}
